import { t } from "i18next";

const PLACEHOLDER_TRANS_DICT = {
  "{{recipient.FirstName}}": t("RichTextEditor.InsertName"),
  "{{recipient.LastName}}": t("RichTextEditor.InsertLastName"),
};

const PLACEHOLDER_TO_VALUE_DICT = {
  [`{{${t("RichTextEditor.InsertName")}}}`]: "{{recipient.FirstName}}",
  [`{{${t("RichTextEditor.InsertLastName")}}}`]: "{{recipient.LastName}}",
};

const findAndReplaceStrings = (content, dict, withBruckets) => {
  if (typeof content !== "string") return "";
  if (!dict) return content;

  return content.replace(
    new RegExp(Object.keys(dict).join("|"), "g"),
    (matched) => {
      if (dict[matched]) {
        if (withBruckets) return `{{${dict[matched]}}}`;
        return dict[matched];
      }
      return matched;
    }
  );
};

export class MessagesDto {
  static setupBalance(data) {
    return {
      smsBalance: data.smsBalance,
      emailBalance: data.emailBalance,
    };
  }

  static setupPlaceholders(data) {
    const tags = data.tags;

    if (!Array.isArray(tags)) return [];

    const placeholders = tags.map((tag) => ({
      value: tag,
      label: PLACEHOLDER_TRANS_DICT[tag],
    }));

    return {
      placeholders,
      dict: {
        valueToPlaceholder: PLACEHOLDER_TRANS_DICT,
        placeholderToValue: PLACEHOLDER_TO_VALUE_DICT,
      },
    };
  }

  static setupMessage(data) {
    const recipientsFullNames = data.recipients?.map(
      (rec) => `${rec.firstName} ${rec.lastName}`
    );
    return {
      id: data.id,
      channel: data.channel,
      content: findAndReplaceStrings(
        data.content,
        PLACEHOLDER_TRANS_DICT,
        true
      ),
      recipients: recipientsFullNames,
      sentAt: data.sentAt,
      title: data.subject,
    };
  }

  static setupCreatedCampaign(data) {
    return {
      channel: data.channel,
      content: findAndReplaceStrings(data.message, PLACEHOLDER_TO_VALUE_DICT),
      name: data.subject,
      recipients: data.recipients.map((rec) => rec.value),
      subject: data.subject,
    };
  }

  static setupSms(data) {
    const smsList = data.sms || [];
    return smsList.map((sms) => this.setupMessage(sms));
  }

  static setupEmails(data) {
    const emailList = data.email || [];
    return emailList.map((email) => this.setupMessage(email));
  }

  static setupCampaign(data) {
    const message = data.campaign;
    return this.setupMessage(message);
  }
}
